import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Countdown extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      countdown: props.enabled ? props.startTimeSeconds : 'vs',
    };

    this.intervalId = this.intervalId;

    if (props.enabled === false) {
      return;
    }

    this.intervalId = setInterval(() => {
      if (this.state.countdown === 1) {
        clearInterval(this.intervalId);
        this.props.timerComplete();
      } else {
        this.setState({ countdown: this.state.countdown - 1 });
      }
    }, 1000);
  } 

  componentWillReceiveProps(nextProps) {
    if (nextProps.enabled === false) {
      clearInterval(this.intervalId);
      this.setState({ countdown: 'vs' });
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }
  
  render() {
    return (
      <div>{this.state.countdown}</div>
    );
  }
}

Countdown.propTypes = {
  timerComplete: PropTypes.func, 
  startTimeSeconds: PropTypes.number,
  enabled: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/countdown/countdown.js